import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="guarantee-title" className="bg-turquoise px-5 py-20 md:py-24" data-id="element-105" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-2xl rounded-card bg-white p-8 text-center shadow-lift md:p-12" data-id="element-106" data-mp="9tl6ys2559ro">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-turquoise-tint text-pine" data-id="element-107" data-mp="ev0rmj0epe9j">
          <ShieldCheckIcon className="h-7 w-7" strokeWidth={1.75} aria-hidden="true" data-id="element-108" data-mp="jqg3j5eut03b" />
        </span>
        <h2 id="guarantee-title" className="mt-6 text-2xl font-extrabold tracking-tight text-pine md:text-3xl" data-id="element-109" data-mp="ns1bqdgg0q76">
          Get Your Money Back and Keep It Anyway.
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-slate-body" data-id="element-110" data-mp="ximac0w49uq3">
          Use <strong className="font-semibold text-ink" data-id="element-111" data-mp="12k37pmfe6z1x">LACROSSE READY 360™</strong> for 30 days. If it does not save
          you hours of planning and make you feel steadier on the sideline, email us and we refund you in full — and
          you keep every volume and every bonus.
        </p>
      </Reveal>
    </section>;
}